import React, { useEffect, useLayoutEffect, useState } from "react";
import { APP_CONST } from "../config/const";
import LoginModal from "../views/components/authModals/LoginModal";
import MobileNumberModal from "../views/components/authModals/MobileNumberModal";
import MobileNumberVerifyModal from "../views/components/authModals/MobileNumberVerifyModal";
import RegisterModal from "../views/components/authModals/RegisterModal";
import ForgotPasswords from "../views/components/authModals/ForgotPassword";
import ResetPassword from "../views/components/authModals/ResetPassword";

const ModalWrapper = ({
  defaultShow,
  handleClose: componentState,
  agentCode = null,
}) => {
  const [showAuthModals, setShowAuthModals] = useState({
    login: false,
    register: false,
    mobileNumber: false,
    verifyNumber: false,
    forgotpassword: false,
    resetpassword: false,
  });
  useEffect(() => {
    if (defaultShow && defaultShow in showAuthModals) {
      handleModalShow(defaultShow);
    }
  }, [defaultShow]);
  const handleModalShow = (modalName) => {
    setShowAuthModals((p) => ({ ...p, [modalName]: true }));
  };

  const handleModalClose = (modalName, actionType = "auto") => {
    setShowAuthModals((p) => ({ ...p, [modalName]: false }));
    if (actionType === "manual" && componentState) {
      componentState(false);
    }
  };

  return (
    <>
      {showAuthModals.login && (
        <LoginModal
          show={showAuthModals.login}
          handleClose={(actionType) =>
            handleModalClose(APP_CONST.AUTH_MODAL.LOGIN, actionType)
          }
          handleModalShow={handleModalShow}
        />
      )}
      {showAuthModals.mobileNumber && (
        <MobileNumberModal
          show={showAuthModals.mobileNumber}
          handleClose={(actionType) =>
            handleModalClose(APP_CONST.AUTH_MODAL.MOBILE_NUMBER, actionType)
          }
          handleModalShow={handleModalShow}
        />
      )}
      {showAuthModals.verifyNumber && (
        <MobileNumberVerifyModal
          show={showAuthModals.verifyNumber}
          handleClose={(actionType) =>
            handleModalClose(APP_CONST.AUTH_MODAL.VERIFY_NUMBER, actionType)
          }
          handleModalShow={handleModalShow}
        />
      )}
      {showAuthModals.register && (
        <RegisterModal
          show={showAuthModals.register}
          handleClose={(actionType) =>
            handleModalClose(APP_CONST.AUTH_MODAL.REGISTER, actionType)
          }
          handleModalShow={handleModalShow}
          agentCode={agentCode}
        />
      )}

      {showAuthModals.forgotpassword && (
        <ForgotPasswords
          show={showAuthModals.forgotpassword}
          handleClose={(actionType) =>
            handleModalClose(APP_CONST.AUTH_MODAL.FORGOTO_PASSWORD, actionType)
          }
          handleModalShow={handleModalShow}
        />
      )}
      {showAuthModals.resetpassword && (
        <ResetPassword
          show={showAuthModals.resetpassword}
          handleClose={(actionType) =>
            handleModalClose(APP_CONST.AUTH_MODAL.RESET_PASSWORD, actionType)
          }
          handleModalShow={handleModalShow}
        />
      )}
    </>
  );
};
export default ModalWrapper;
